import { Paper, Stack, Transition } from "@mantine/core";
import type { ChatListProps } from "./ChatQueue/FlatChatList";
import { FlatChatList } from "./ChatQueue/FlatChatList";
import { GroupedChatList } from "./ChatQueue/GroupedChatList";
import classes from "./chat-components.module.css";

interface ChatQueueProps extends ChatListProps {
    isGroupChatsByPartner: boolean;
}

export function ChatQueue({ chats, isGroupChatsByPartner, ...rest }: ChatQueueProps) {
    const chatList = isGroupChatsByPartner ? (
        <GroupedChatList chats={chats} {...rest} />
    ) : (
        <FlatChatList chats={chats} {...rest} />
    );

    return (
        <Transition mounted={chats.length > 0} transition="fade-right" duration={300} timingFunction="ease">
            {(transitionStyle) => (
                <Paper
                    id="chat-queue"
                    component="aside"
                    radius="md"
                    shadow="sm"
                    bg="var(--exwo-color-panel-bg)"
                    className={classes.chat_queue}
                    style={{ ...transitionStyle }}
                >
                    <Stack component="nav" gap="0" style={{ borderRadius: "var(--mantine-radius-md)" }}>
                        {chatList}
                    </Stack>
                </Paper>
            )}
        </Transition>
    );
}
